import qs from 'qs'
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import routeNames from './route-names'
// Modules
import cancellation from './cancellation'
// import connectivityChecker from './connectivity'
import contact from './contact'
import contract from './contract'
import customer from './customer'
import invoice from './invoice'
import productInventory from './product-inventory'
import reservation from './reservation'
import search from './search'
import sipcentric from './sipcentric'
import staffMember from './staff-member'
import bespoke from './bespoke'
import bundle from './bundle'
import scheduledReport from './scheduled-report'
import {pick} from 'lodash'

const Login = () => import(/* webpackChunkName: "wims-portal-app-wrapper" */'@/views/auth/Login')
const Logout = () => import(/* webpackChunkName: "wims-portal-app-wrapper" */'@/views/auth/Logout')
const BaseNotFound = () => import(/* webpackChunkName: "wims-portal-app-wrapper" */'@framework/components/BaseNotFound')

Vue.use(VueRouter)

export const routes = [
    {
        path: '/',
        redirect: {path: '/customers'}
    },
    {
        path: '/login',
        alias: '/auth-check',
        name: routeNames.LOGIN,
        component: Login
    },
    {
        path: '/logout',
        name: routeNames.LOGOUT,
        component: Logout
    },
    cancellation,
    contact,
    contract,
    invoice,
    customer,
    productInventory,
    reservation,
    // connectivityChecker,
    staffMember,
    sipcentric,
    bespoke,
    bundle,
    scheduledReport,
    search,
    {
        path: '*',
        component: BaseNotFound,
        props: {
            redirect: {path: '/'}
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    parseQuery (query) {
        return qs.parse(query)
    },
    stringifyQuery (query) {
        const result = qs.stringify(query, {arrayFormat: 'brackets'})
        return result ? `?${result}` : ''
    }
})

router.beforeEach(async (to, from, next) => {
    const nextRoute = store.getters['auth/nextRoute']

    if ((to.path !== nextRoute.path) && !['/login', '/auth-check'].includes(to.path)) {
        const keys = ['name', 'query', 'params', 'path']

        store.dispatch('auth/resetMfaError')
        store.dispatch('auth/setNextRoute', pick(to, keys))
        store.dispatch('auth/setFromRoute', pick(from, keys))
    }

    if (to.fullPath === from.fullPath && from.path !== '/') {
        return next(false)
    }

    next()
})

export default router
